<ng-container #primarySlot></ng-container>
<div class="label">
  <ng-content></ng-content>
</div>
<ng-container #secondarySlot></ng-container>
